import styled from "styled-components";
import { AmazonLogoSvg } from "../index";
export const AmazonLogoLight = styled(AmazonLogoSvg) `
  & > g > path[aria-label="letter"] {
    fill: #343a40;
  }
  & > g > path[aria-label="streak"] {
    fill: #ff9900;
  }
`;
export const AmazonLogoDark = styled(AmazonLogoSvg) `
  & > g > path[aria-label="letter"] {
    fill: #fff;
  }
  & > g > path[aria-label="streak"] {
    fill: #ff9900;
  }
`;
